<div class="animals-grid">
  @for (card of cards; track card.quotaId) {
    <mat-card
      class="animal-card"
      [class.selected]="isSelected(card)"
      (click)="onCardClick(card)">

      <mat-card-content class="card-content">
        <!-- Заголовок -->
        <h3 class="card-title">
          {{ 'dashboard.deliveries' | translate }} {{ getMeatName(card) }}
        </h3>

        <!-- SVG круговая диаграмма с иконкой -->
        <div class="donut-container">
          <svg
            width="120"
            height="120"
            viewBox="0 0 120 120"
            preserveAspectRatio="xMidYMid meet">
            <!-- Фоновый круг -->
            <circle
              cx="60"
              cy="60"
              r="53"
              stroke="#E9ECF2"
              stroke-width="14"
              fill="none" />

            <!-- Прогресс круг -->
            <circle
              cx="60"
              cy="60"
              r="53"
              stroke="#F17406"
              stroke-width="14"
              fill="none"
              [attr.stroke-dasharray]="2 * 3.14159 * 53"
              [attr.stroke-dashoffset]="getCircleDashOffset(getProgress(card), 53)"
              stroke-linecap="round"
              transform="rotate(-90 60 60)" />
          </svg>

          <!-- Иконка в центре -->
          <div class="icon-center">
            <img
              [src]="getMeatIcon(card.meatType.alias)"
              alt="{{ getMeatName(card) }}"
              width="60"
              height="60" />
          </div>
        </div>

        <!-- Объем доставки -->
        <div class="volume-section">
          <span class="volume-number">{{ kgToTons(card.deliveredVolume) }}</span>
          <span class="volume-unit">{{ 'dashboard.tons' | translate }}</span>
        </div>

        <!-- Линия роста/снижения -->
        @if (getGrowthData(card); as growth) {
          <div class="growth-line">
            <span class="growth-arrow" [style.color]="growth.color">
              {{ growth.arrow }}
            </span>
            <span class="growth-text">
              {{ growth.fullText }}
            </span>
          </div>
        }
      </mat-card-content>
    </mat-card>
  }
</div>
